export { default } from './BackgroundCarousel';
